import styled from '@emotion/styled'
import { ITheme } from 'utils/type'
import { Row, Col } from 'react-bootstrap'

interface IContentSectionelementProps {
  theme: ITheme
}
export const TitleDiv = styled.div<IContentSectionelementProps>`
  label: TitleDiv;
  color: ${(props) => props.theme.colors.primary};
  font-size: ${(props) => props.theme.font.size.largest};
  font-weight: 600;
  @media (max-width: 719px) {
    font-size: ${(props) => props.theme.font.size.medium};
  }
`

export const TickListDiv = styled.div`
  label: TickListDiv;
  display: flex;
  align-items: baseline;
  font-size: 18px;
  > img {
    height: 14px;
    padding-right: 6px;
  }
`

export const BenefitsToggleParentDiv = styled.div`
  label: BenefitsToggleParentDiv;
  display: flex;
  align-items: center;
  flex-direction: column;
`

export const BenefitsToggleHRDiv = styled.div`
  label: BenefitsToggleHRDiv;
  width: 100%;
`

export const BenefitsToggleTextDiv = styled.div<IContentSectionelementProps>`
  label: BenefitsToggleTextDiv;
  position: relative;
  top: -15px;
  background-color: #F2EDE8;
  width: 220px;
  cursor: pointer;
`

export const BenefitsToggleText = styled.button<IContentSectionelementProps>`
  label: BenefitsToggleText;
  color: ${(props) => props.theme.colors.textDarkblack};
  font-size: 12pt;
  text-decoration-line: underline;
  font-weight: ${(props) => props.theme.font.weight.bold};
  background: none;
  border: none;
`

export const BlackNumberCircle = styled.span<IContentSectionelementProps>`
  label: BlackNumberCircle;
  padding: 12px;
  background-color: ${(props) => props.theme.colors.secondary};
  color: ${(props) => props.theme.colors.white};
  height: 35px;
  width: 35px;
  text-align: center;
  border-radius: 50%;
  display: inline-block;
  vertical-align: middle;
  line-height: 12px;
  margin-right: 24px;
`

export const NumberedBulletPointHeadingDiv = styled.div`
  label: NumberedBulletPointHeadingDiv;
  display: flex;
  align-items: center;
  margin-bottom: 12px;
`

export const StyledH2 = styled.h2`
  label: StyledH2;
  font-size: 28px !important;
  line-height: 28pt !important;
  color: ${(props) => props.theme.colors.textDarkblack} !important;
`

export const PinkStyledH2 = styled.h2`
  label: StyledH2;
  font-size: 28px !important;
  line-height: 28pt !important;
  color: ${(props) => props.theme.colors.primary} !important;
`


export const IndentedP = styled.p`
  label: IndentedP;
  margin-left: 78px;
  margin-bottom: 60px !important;
`
